import type { HTMLAttributes } from 'react';
import { useIntl } from 'react-intl';

type MoneyProps = {
    value: number;
    currency: string;
} & HTMLAttributes<HTMLSpanElement>;

const Money = ({ value, currency, ...props }: MoneyProps) => {
    const format = useIntl();

    return (
        <span {...props}>
            {format.formatNumber(value, {
                style: 'currency',
                currency,
            })}
        </span>
    );
};

export default Money;
